import { MonoTypeOperatorFunction } from 'rxjs';

/**
 * Behavior-preserving replacement for `@angular/fire/performance`'s
 * `traceUntilFirst`. No product configures Firebase Performance
 * (`providePerformance`/`getPerformance` is never called), so the original was
 * already an effective no-op. Kept as a pass-through operator so the handful of
 * `.pipe(traceUntilFirst(name), …)` call sites don't have to change shape.
 */
export function traceUntilFirst<T>(_name: string): MonoTypeOperatorFunction<T> {
  return (source) => source;
}
